export const vcodeIamges = [
  require('@/assets/vcodeIamges/vcode_2.jpg'),
  require('@/assets/vcodeIamges/vcode_3.jpg'),
  require('@/assets/vcodeIamges/vcode_4.jpg'),
  require('@/assets/vcodeIamges/vcode_5.jpg'),
  require('@/assets/vcodeIamges/vcode_6.jpg'),
  require('@/assets/vcodeIamges/vcode_7.jpg'),
]
